import { render } from "./MinisterFilter.vue?vue&type=template&id=7aba20c9&scoped=true&ts=true"
import script from "./MinisterFilter.ts?vue&type=script&lang=ts"
export * from "./MinisterFilter.ts?vue&type=script&lang=ts"

import "./MinisterFilter.scss?vue&type=style&index=0&id=7aba20c9&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aba20c9"]])

export default __exports__